import React from 'react'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import MovingBackground from '../../../../../partials/MovingBackground/MovingBackground'
import { MovingHeaderSize } from '../../../../../partials/MovingBackground/components/MovingHeader'

interface SolutionCardProps {
  solution: {
    id: string
    className: string
    background: {
      component: string
      mobileComponent?: string
      className?: string
    }
    filter?: string
  }
}

const SolutionCard = ({ solution: { id, className, background } }: SolutionCardProps) => {
    const { component, mobileComponent, className: bgClassName } = background
    return (
        <div className='h-full'>
            <div
                className={twMerge(
                    'min-h-[347px] lg:min-h-[372px]',
                    'relative overflow-hidden h-full',
                    className,
                )}
            >
                <MovingBackground
                    component={component}
                    mobileComponent={mobileComponent}
                    classes={{
                        wrapper: twMerge('h-full'),
                        background: bgClassName,
                    }}
                    size={MovingHeaderSize.SMALL}
                >
                    <div className={twMerge('z-10 px-6 py-8 relative flex flex-col h-full')}>
                        <div className={twMerge('flex gap-x-4 items-start justify-between')}>
                            <FormattedMessage id={id}>
                                {(value) => (
                                    <span className={twMerge('improvement-card--title transition text-black')}>
                                        {value}
                                    </span>
                                )}
                            </FormattedMessage>
                        </div>
                        <div className='flex flex-col h-full justify-end pt-15'>
                            <FormattedMessage id={`${id}.subtitle`}>
                                {(value) => (
                                    <span className={twMerge('improvement-card--subtitle transition text-black')}>
                                        {value}
                                    </span>
                                )}
                            </FormattedMessage>
                            <div className={twMerge('pt-4 z-10 flex transition text-black')}>
                                <FormattedMessage id={`${id}.description`}>
                                    {(value) => <p dangerouslySetInnerHTML={{ __html: value.toString() }}></p>}
                                </FormattedMessage>
                            </div>
                        </div>
                    </div>
                </MovingBackground>
            </div>
        </div>
    )
}

export default SolutionCard
